<div style="display: block">
	<canvas ngChartjs
		[datasets]="chartDatasets"
		[labels]="chartLabels"
		[chartType]="type"
		[legend]="legend"
		[options]="options"
		[colors]="colors"
	></canvas>
</div>